import { useEffect, useRef, useState } from 'react';

export interface UseScriptProps {
  src: string;
  enabled: boolean;
  onLoad?: () => void;
  defer: boolean;
}

const useScript = ({ src, enabled = true, onLoad, defer = false }: UseScriptProps) => {
  const onLoadRef = useRef(onLoad);
  const [isLoading, setIsLoading] = useState(enabled);

  useEffect(() => {
    if (!enabled) {
      return;
    }

    setIsLoading(true);

    const script = document.createElement('script');

    script.src = src;
    script.defer = defer;

    script.onload = () => {
      onLoadRef.current?.();
      setIsLoading(false);
    };

    document.body.appendChild(script);

    return () => {
      document.body.removeChild(script);
    };
  }, [enabled, defer, src]);

  return {
    isLoading,
  };
};

export default useScript;
